import { ActivatedRoute, Router } from '@angular/router';
import { AllSarService } from '../../services/all-sar-service';
import { CommonService } from 'src/app/core/services/common.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { debounceTime, switchMap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { GroupDescriptor, State } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/internal/Observable';
import { requestConst } from 'src/app/core/constants/request.const';
import { RoleConstant } from 'src/app/core/constants/role.constants';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ALLSARABUExcelHeaders, ALLSARCNAEPBUExcelHeaders } from 'src/app/core/models/excel-header.model';
import { ExportService } from 'src/app/core/services/export.service';
import { ExportNewService } from 'src/app/core/services/export-new.service';
import { AllSarConst } from 'src/app/core/constants/all-sar.constant';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    standalone: false
})
export class OrdersComponent implements OnInit {
  @ViewChild(DataBindingDirective)
  dataBinding!: DataBindingDirective;

  public loadingPanelVisible = false;
  public multiple = false;
  public allowUnsort = true;
  public gridView: any;
  public skip = 0;
  public pageSize = 10;
  public sort!: any;
  public groups: GroupDescriptor[] = [];
  public filters!: any;
  public buttonCount = 10;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public totalRecords = 0;
  public userBelongsToSensitiveGroup: boolean = false;
  public searchUserRequestControl = new FormControl();
  public osdata: Array<string> = [];
  public isAdmin = false;
  public buName: string = "";
  private currentUserCai: string = "";
  private displayName: string = "";

  public state: State = {
    skip: 0,
    take: this.pageSize,
    filter: {
      logic: "and",
      filters: [{ field: "", operator: "", value: "" }]
    },
  };
  public body = {
    "buName": this.buName,
    "isAdminUser": this.isAdmin,
    "dataSourceRequest": this.state
  }
  constructor(public myRequestsService: AllSarService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private exportService: ExportService,
    private exportNewService: ExportNewService
  ) {
    this.searchUserRequestControl.valueChanges.pipe(
      debounceTime(600),
      switchMap(async (changedValue) => this.onFilterSearch(changedValue)),
    ).subscribe();


  }
  public ngOnInit(): void {
    this.buName = this.commonService.getUserBUName();

    if (this.buName == "ABU") {
      this.pageSize = 15;
      this.state.take = this.pageSize;
    }
    this.loadGrid();
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.state.group = groups;
    this.groups = groups;
    this.loadGrid();
  }

  private loadGrid(): void {
    this.loadingPanelVisible = true;
    if (this.commonService.getUserRoleName() === RoleConstant.ESAR_Admin) {
      this.isAdmin = true;
    }
    this.body.isAdminUser = this.isAdmin;
    this.body.buName = this.buName;
    this.BindDataTogrid();

  }


  private BindDataTogrid(): void {
    this.myRequestsService.getAllRequestsData(this.body).subscribe(result => {
      if (this.groups.length > 0) {
        let data = result as any;
        this.gridView = {
          data: data?.groups,
          total: data?.total,
        };
        this.totalRecords = this.gridView?.total ?? 0;
      }
      else {
        this.gridView = result;
        this.totalRecords = this.gridView?.total ?? 0;
      }
      this.loadingPanelVisible = false;
    });
  }


  public allData = (): Observable<any> => {
    this.body.dataSourceRequest.take = this.gridView?.total;
    const observable = this.myRequestsService.getAllRequestsData((this.body));
    observable.subscribe((result) => {
    });

    return observable;
  };

  public onFilter(inputValue: any): void {
    this.loadingPanelVisible = true;
    let serachtext = inputValue?.target.value ?? "";
    if (serachtext != null && serachtext != undefined && serachtext != "") {
      this.state.filter = this.filters;
      this.state.filter = this.filters;
      this.myRequestsService.getAllRequestsData(this.body)
        .subscribe(result => {
          this.gridView = result;
          this.totalRecords = this.gridView?.total ?? 0;
          this.loadingPanelVisible = false;
        });
    }
    else {
      this.loadGrid();
    }
  }

  public onFilterSearch(inputValue: any): void {
    this.loadingPanelVisible = true;
    let serachtext = inputValue ?? "";

    this.state.filter = this.filters;

    let searchFilter = this.getFilterObjectForSearch(serachtext)
    if (this.filters == null || this.filters == undefined) {
      this.filters = searchFilter;
    }
    else if (this.filters.filters.filter((item: { field: string; }) => item.field === "searchtext").length == 0) {
      this.filters.filters.push(searchFilter.filters[0]);
    }
    else {
      this.filters.filters.filter((item: { field: string; }) => item.field === "searchtext")[0].value = serachtext;
    }
    this.state.filter = this.filters;
    this.state.skip = 0;
    this.state.take = this.pageSize;

    this.myRequestsService.getAllRequestsData(this.body)
      .subscribe(result => {
        this.gridView = result;
        this.loadingPanelVisible = false;
        this.totalRecords = this.gridView?.total ?? 0;
      });

  }

  private getStateObjectForSearch(searchText: string): State {
    return {
      skip: 0,
      take: this.pageSize,
      filter: {
        logic: "or",
        filters: [
          {
            field: "searchtext",
            operator: "contains",
            value: searchText,
          }
        ]
      }
    };
  }

  private getFilterObjectForSearch(searchText: string): any {
    return {
      logic: "and",
      filters: [
        {
          field: "searchtext",
          operator: "contains",
          value: searchText,
        }
      ]
    };
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.filters = state.filter;

    let searchFilter = this.getFilterObjectForSearch(this.searchUserRequestControl.value ?? "")
    if (this.filters == null || this.filters == undefined) {
      this.filters = searchFilter;
    }
    else if (this.filters.filters.filter((item: { field: string; }) => item.field === "searchtext").length == 0) {
      this.filters.filters.push(searchFilter.filters[0]);
    }
    else {
      this.filters.filters.filter((item: { field: string; }) => item.field === "searchtext")[0].value = this.searchUserRequestControl.value ?? "";
    }


    this.state.filter = this.filters;
    this.state.skip = state.skip;
    this.state.take = state.take;
    this.skip = state.skip;
    this.pageSize = state.take;
    this.state.sort = state.sort;
    this.sort = state.sort;
    this.loadGrid();
  }

  @ViewChild(TooltipDirective)
  public tooltipDir!: TooltipDirective;
  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (
      (element.nodeName === "TD" || element.nodeName === "TH") &&
      element.offsetWidth < element.scrollWidth
    ) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }

  manage(requestId: number) {
    const path = `false/false/${requestId}`;
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`../sar/${requestConst.viewSAR}/${path}`], {
        relativeTo: this.route
      })
    );
    window.open(url, '_blank');
  }

  navViewAction(dataItem: any) {
    let changeType: string = dataItem.action ? dataItem.action.split(' ').join('_') : '';
    if (dataItem.status !== 'Draft') {
      this.router.navigate([`../sar/${requestConst.approvalDetail}/${dataItem.id}/${dataItem.sarId}/${dataItem.issueId}/${dataItem?.actionNumber}/${changeType}`],
        { state: { requestId: dataItem.id, requestNumber: dataItem.sarId, requestIssueId: dataItem.issueId, actionNumber: dataItem?.actionNumber, changeType: dataItem.action, createdBY: dataItem.createdBy }, relativeTo: this.route });
    }
  }

  exportRecords() {
    this.body.dataSourceRequest.take = this.gridView?.total;
    this.myRequestsService.getAllRequestsForExport(this.body).subscribe({
      next: (response: any) => {
        if (response !== null) {
          let data: any;
          let excelHeaders: any;
          if (this.buName == "ABU") {
            data = this.mapExcelRecordsForABU(response);
            excelHeaders = ALLSARABUExcelHeaders;
          } else {
            data = this.mapExcelRecordsForCNAEPBU(response);
            excelHeaders = ALLSARCNAEPBUExcelHeaders;
          }
          this.exportNewService.exportExcel(data, [excelHeaders], `${AllSarConst.FILENAME} ${new Date().toISOString()}` + '.xlsx');
        }
      }
    });
  }

  mapExcelRecordsForABU(response: any): any {
    let data = response.map((x: any) => {
      return {
        sarId: x.sarId,
        businessUnit: x.businessUnit,
        title: x.title,
        actionNumber: x.actionNumber,
        action: x.action,
        supplier: x.supplier,
        supplierNumber: x.supplierNumber,
        priority: x.priority,
        branchPlant: x.branchPlant,
        owner: x.owner,
        createdOn: x.createdOn,
        description: x.description,
        uom: x.uom,
        mrp: x.mrp,
        lineNumber: x.lineNumber,
        materialNumber: x.materialNumber,
        status: x.status,
        lastModified: x.lastModified,
        modifiedBy: x.modifiedBy,
        assignedTo: x.assignedTo,
        estimated: x.estimated,
        recommendedMin: x.recommendedMin,
        recommendedMax: x.recommendedMax,
        annualUsageForecast: x.annualUsageForecast,
        changeInValue: x.changeInValue,
        totalValue: x.totalValue,
        qaCode: x.qaCode,
        isModelUpdateRequired: x.isModelUpdateRequired,
        equipmentCriticality: x.equipmentCriticality
      };
    });
    return data;
  }

  mapExcelRecordsForCNAEPBU(response: any): any {
    let data = response.map((x: any) => {
      return {
        sarId: x.sarId,
        businessUnit: x.businessUnit,
        title: x.title,
        actionNumber: x.actionNumber,
        action: x.action,
        priority: x.priority,
        owner: x.owner,
        createdOn: x.createdOn,
        description: x.description,
        manufacturer: x.manufacturer,
        manufacturerPartNumber: x.manufacturerPartNumber,
        uom: x.uom,
        segment: x.segment,
        mrp: x.mrp,
        lineNumber: x.lineNumber,
        materialNumber: x.materialNumber,
        materialGroupCode: x.materialGroupCode,
        shortDescription: x.shortDescription,
        enrichedDescription: x.enrichedDescription,
        dataChangeType: x.dataChangeType,
        newData: x.newData,
        plant: x.plant,
        plantDF: x.plantDF,
        storageLocation: x.storageLocation,
        storageLocationDF: x.storageLocationDF,
        recommendedMin: x.recommendedMin,
        recommendedMax: x.recommendedMax,
        valuationType: x.valuationType,
        valuationTypeDF: x.valuationTypeDF,
        bin: x.bin,
        status: x.status,
        submittedBy: x.ubmittedBy,
        submittedOn: x.submittedOn,
        assignedTo: x.assignedTo,
        assignedGroup: x.assignedGroup,
        approvedBy: x.approvedBy,
        approvedOn: x.approvedOn,
        closedBy: x.closedBy,
        closedOn: x.closedOn
      };
    });
    return data;
  }

}
